import { useState, useEffect } from "react";
import { useZoom } from './components/zoom.js';

import Grid162 from './components/Grid-boletins.js';

import GlobalStyle from "../../../styles/global4.js";
import "react-toastify/dist/ReactToastify.css";
import styled from "styled-components";



const Geral = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  div {
    transition: transform 0.1s;
  }


    &.zoom-110 {
    font-size: 0.95rem;
    table {
      transform: scale(0.95);
      transform-origin: center;
    }
  }

  &.zoom-125 {
    font-size: 0.90rem;
    table {
      transform: scale(0.89);
      transform-origin: center;
    }
  }

  &.zoom-150 {
    font-size: 0.90rem;
    table {
      transform: scale(0.89);
      transform-origin: center;
    }
  }

  &.zoom-175 {
    font-size: 0.8rem;
    table {
      transform: scale(0.8);
      transform-origin: center;
    }
  }
  @media (max-width:768px) {
    padding: 20px 10px;
    overflow-y: auto;
    width: 100vw;
    height: 100vh;

  }
  

`;


const Div = styled.div`
  width: auto;


  @media (max-width:768px) {
    width: 90%;

  }
`;








export const ZoomWrapper = styled.div`
  transform-origin: top left;
  ${({ scale }) => `
    transform: scale(${scale});
    /* truque: compensa a largura para não cortar quando escala > 1 */
    width: ${(100 / scale).toFixed(4)}%;
  `}
`;

function App() {

  //----------------------------//
  //Ip's da api e do front

  const urlApi = process.env.REACT_APP_API_URL;


  const getToken = async () => {
    window.location.href = `https://gestao.cooperval.coop.br/apps/boletins-web`;
  };

  useEffect(() => {

    getToken();

  }, [])


  const [zoomClass, setZoomClass] = useState("");

  useEffect(() => {
    const detectZoom = () => {
      const zoom = window.devicePixelRatio;

      if (zoom >= 1.7) {
        setZoomClass("zoom-175");
      } else if (zoom >= 1.5) {
        setZoomClass("zoom-150");
      } else if (zoom >= 1.25) {
        setZoomClass("zoom-125");
      } else if (zoom >= 1.1) {
        setZoomClass("zoom-110");
      } else {
        setZoomClass(""); // padrão
      }
    };

    window.addEventListener("resize", detectZoom);
    detectZoom();

    return () => window.removeEventListener("resize", detectZoom);
  }, []);



  // Zoom com persistência
  const { zoom, zoomIn, zoomOut, resetZoom } = useZoom("CCT_ZOOM", { initial: 1, min: 0.6, max: 1.8, step: 0.1 });

  // Atalhos (Alt+= / Alt+- / Alt+0)
  useEffect(() => {
    const onKeyDown = (e) => {
      if (!e.altKey) return;
      if (e.key === "=" || e.key === "+") { e.preventDefault(); zoomIn(); }
      else if (e.key === "-") { e.preventDefault(); zoomOut(); }
      else if (e.key === "0") { e.preventDefault(); resetZoom(); }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [zoomIn, zoomOut, resetZoom]);

  return (
    <ZoomWrapper scale={zoom}>
      {/* <Geral className={zoomClass}> */}

      <Geral >
        <Div>
          <Grid162 urlApi={urlApi} zoomIn={zoomIn} zoomOut={zoomOut} zoom={zoom} />
        </Div>



        <GlobalStyle />
      </Geral>
    </ZoomWrapper>
  );
}

export default App;
